/* eslint-disable no-underscore-dangle */
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { AppRoutes } from "src/app/constants";
import { RootState } from "src/app/store";
import { ToastController } from "@ionic/angular";
import { GenericReportPage } from "../generic-report/generic-report.page";

@Component({
  selector: "app-success-report",
  templateUrl: "../generic-report/generic-report.page.html",
  styleUrls: ["../generic-report/generic-report.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessReportPage extends GenericReportPage {
  constructor(protected _store: Store<RootState>, protected _i18n: TranslateService, protected _toastController: ToastController) {
    super(_store, _i18n, _toastController);

    this.slug = this.routes.successReport;
    this.i18nKey = "SUCCESS_REPORT";
    this.breadcrumbs = [
      { name: this._i18n.instant("DASHBOARD.BREADCRUMB_NAME"), link: `/${AppRoutes.home}` },
      {
        name: this._i18n.instant(`${this.i18nKey}.BREADCRUMB_NAME`),
        link: `/${AppRoutes.reports}/${AppRoutes.successReport}/${AppRoutes.history}`,
      },
    ];
  }
}
